import type { Recipe } from '@ricettario/shared';
import { resolveIcon } from '../lib/icons';

type Size = 'sm' | 'md' | 'lg' | 'hero';

type CoverRecipe = Pick<Recipe, 'name' | 'coverImage' | 'tags'> & {
  icon?: string | null;
};

type Props = {
  recipe: CoverRecipe;
  size?: Size;
  className?: string;
};

const EMOJI_SIZE: Record<Size, string> = {
  sm: 'text-2xl',
  md: 'text-5xl',
  lg: 'text-7xl',
  hero: 'text-[5rem] md:text-[6rem]',
};

export default function RecipeCover({ recipe, size = 'md', className = '' }: Props) {
  if (recipe.coverImage) {
    return (
      <img
        src={`/media/${recipe.coverImage}`}
        alt=""
        loading="lazy"
        className={`h-full w-full object-cover ${className}`}
      />
    );
  }
  const icon = resolveIcon(recipe);
  return (
    <div
      className={`h-full w-full flex items-center justify-center ${EMOJI_SIZE[size]} ${className}`}
      style={{
        background: `linear-gradient(135deg, ${icon.gradient[0]}, ${icon.gradient[1]})`,
      }}
      aria-hidden
    >
      <span className="drop-shadow-sm">{icon.emoji}</span>
    </div>
  );
}
